import apiClient from './apiClient';

export const assurancesAPI = {
  cases: {
    list: (params) => apiClient.get('/assurances/cases/', { params }),
    get: (id) => apiClient.get(`/assurances/cases/${id}/`),
    create: (data) => apiClient.post('/assurances/cases/', data),
    update: (id, data) => apiClient.put(`/assurances/cases/${id}/`, data),
    delete: (id) => apiClient.delete(`/assurances/cases/${id}/`),
  },
  contracts: {
    list: (params) => apiClient.get('/assurances/contracts/', { params }),
    get: (id) => apiClient.get(`/assurances/contracts/${id}/`),
    create: (data) => apiClient.post('/assurances/contracts/', data),
    update: (id, data) => apiClient.put(`/assurances/contracts/${id}/`, data),
    delete: (id) => apiClient.delete(`/assurances/contracts/${id}/`),
  },
  sinistres: {
    list: (params) => apiClient.get('/assurances/sinistres/', { params }),
    get: (id) => apiClient.get(`/assurances/sinistres/${id}/`),
    create: (data) => apiClient.post('/assurances/sinistres/', data),
    update: (id, data) => apiClient.put(`/assurances/sinistres/${id}/`, data),
    delete: (id) => apiClient.delete(`/assurances/sinistres/${id}/`),
  },
  experts: {
    list: (params) => apiClient.get('/assurances/experts/', { params }),
    get: (id) => apiClient.get(`/assurances/experts/${id}/`),
    create: (data) => apiClient.post('/assurances/experts/', data),
    update: (id, data) => apiClient.put(`/assurances/experts/${id}/`, data),
    delete: (id) => apiClient.delete(`/assurances/experts/${id}/`),
  },
  expertises: {
    list: (params) => apiClient.get('/assurances/expertises/', { params }),
    get: (id) => apiClient.get(`/assurances/expertises/${id}/`),
    create: (data) => apiClient.post('/assurances/expertises/', data),
    update: (id, data) => apiClient.put(`/assurances/expertises/${id}/`, data),
    delete: (id) => apiClient.delete(`/assurances/expertises/${id}/`),
  },
  indemnisations: {
    list: (params) => apiClient.get('/assurances/indemnisations/', { params }),
    get: (id) => apiClient.get(`/assurances/indemnisations/${id}/`),
    create: (data) => apiClient.post('/assurances/indemnisations/', data),
    update: (id, data) => apiClient.put(`/assurances/indemnisations/${id}/`, data),
    delete: (id) => apiClient.delete(`/assurances/indemnisations/${id}/`),
  },
  attestations: {
    list: (params) => apiClient.get('/assurances/attestations/', { params }),
    get: (id) => apiClient.get(`/assurances/attestations/${id}/`),
    create: (data) => apiClient.post('/assurances/attestations/', data),
    update: (id, data) => apiClient.put(`/assurances/attestations/${id}/`, data),
    delete: (id) => apiClient.delete(`/assurances/attestations/${id}/`),
  },
};
